const _jobApis = {
  getList: function () {
    return _axiosService.post(`/WebJob/GetList`);
  },
};
